import { getFundRetrieveLoader } from "gen/endpoints/fund-entities/fund-entities";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export type EntityEditPageParent = "global" | "fundFamily" | "fundFamilySetup";

export const createEntityEditRoutes = (
  parent: EntityEditPageParent,
): RouteObject[] => {
  const idPrefix =
    parent === "global" ? "entitiesEntity" : `${parent}EntitiesEntity`;
  return [
    {
      id: `${idPrefix}Details`,
      path: "",
      lazy: async () => {
        const { EntityEditTabDetails } = await import(
          "features/entities/edit/EntityEditTabDetails"
        );
        return { Component: EntityEditTabDetails };
      },
      handle: {
        title: i18n.t("entity:profile"),
      },
      loader: getFundRetrieveLoader(({ fundFamilyId, entityId }) => ({
        fundFamilyId: fundFamilyId!,
        id: entityId!,
      })),
    },
    // TODO: Support for global allocation rules list
    ...(parent !== "global"
      ? [
          {
            id: `${idPrefix}AllocationsList`,
            path: "allocations",
            lazy: async () => {
              const { EntityEditTabAllocations } = await import(
                "features/entities/edit/EntityEditTabAllocations"
              );
              return { Component: EntityEditTabAllocations };
            },
            handle: {
              title: i18n.t("allocation:edit.allocationRules"),
            },
          },
        ]
      : []),
  ];
};
